import { File, HardDriveDownload } from "lucide-react";
import { FileMessageFile } from "../FileMessage";
import { formatFileSize } from "@/utils/file";
import OptionsMenu from "../OptionMenu";
import LocationLink from "../LocationLink";
import "../messageStyles.css";

interface ReceivedFileMessageProps {
  id: number;
  created: string;
  time: string;
  file: FileMessageFile;
  dkb: number;
}

const ReceivedFileMessage = ({
  id,
  created,
  time,
  file,
  dkb,
}: ReceivedFileMessageProps) => {
  return (
    <div key={id} className="message-container">
      <div className="message-time-container">
        <span className="message-time">{created ? time : "now"}</span>
        <div className="options-menu group">
          <div className="flex items-center gap-2 p-4 received-color rounded-lg min-w-0">
            <div className="file-message-file-container">
              <File size={32} className="file-item" />
              <div className="file-info-container">
                <p className="file-name">{file.fname}</p>
                <p className="file-size">{formatFileSize(dkb)}</p>
              </div>
              <div className="file-preview-container">
                <a
                  href={`data:image/webp;base64,${file.media}`}
                  download={file.dname}
                  title="Download File"
                  className="file-item"
                >
                  <HardDriveDownload size={20} />
                </a>
              </div>
            </div>
          </div>
          <OptionsMenu />
        </div>
        {file.msg.length > 0 && (
          <div className="options-menu group">
            <div className="message-text-container received-color max-w-fit">
              <p className="attachment-message">{file.msg}</p>
            </div>
            <OptionsMenu />
          </div>
        )}
        <LocationLink lat={file.lat} lng={file.lng} />
      </div>
    </div>
  );
};

export default ReceivedFileMessage;
